import styled from "styled-components";

import {
  OVERLAYS,
  QUERIES,
  SPACING,
  SPACING_RESPONSIVE,
} from "../../../utils/constants";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.lg}px;
  max-width: 100%;
  margin: ${SPACING_RESPONSIVE.mobile.pageMargin}px;
  padding: ${SPACING_RESPONSIVE.mobile.cardPadding}px;
  border-radius: ${SPACING.md}px;
  background: var(--hero-background);
  border: 1px solid var(--color-border-light);
  box-shadow: var(--shadow-small);

  @media ${QUERIES.tabletAndUp} {
    margin: ${SPACING_RESPONSIVE.tablet.pageMargin}px;
    padding: ${SPACING_RESPONSIVE.tablet.cardPadding}px;
  }
`;

export const IllustrationBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px;
  border: 1px dashed var(--empty-state-border);
  border-radius: ${SPACING.md}px;
  background: var(--empty-state-background);
  text-align: center;
`;

export const CardStripe = styled.span`
  position: absolute;
  top: 14px;
  left: 0;
  right: 0;
  height: 8px;
  background: ${OVERLAYS.black40};
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xl);
  font-weight: var(--font-weight-bold);
  letter-spacing: -0.01em;
  color: var(--color-text-default);
`;

export const Description = styled.p`
  margin: 0;
  max-width: 90%;
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--color-text-secondary);
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.sm}px;

  @media ${QUERIES.tabletLargeAndUp} {
    flex-direction: row;
  }
`;
